import { createReducer } from 'reducers';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
    REQUESTED,
    SUCCESSFUL,
    FAILED,
    REQUEST_REQUESTED,
    REQUEST_FAILED,
    REQUEST_SUCCESSFUL,
    ADD_CONVERSATION_REQUESTED,
    ADD_CONVERSATION_FAILED,
    ADD_CONVERSATION_SUCCESSFUL,
    COACH_PROFILE_REQUESTED,
    COACH_PROFILE_FAILED,
    COACH_PROFILE_SUCCESSFUL,
    DIVISION_STUDENT_FAILED,
    DIVISION_STUDENT_SUCCESSFUL,
    DIVISION_STUDENT_REQUESTED,
    FILTER_DIVISION_STUDENT_FAILED,
    FILTER_DIVISION_STUDENT_REQUESTED,
    FILTER_DIVISION_STUDENT_SUCCESSFUL,
} from './actionTypes';

const getCuratedArrayFromElasticData = (data) => {
  const array = [];
  const temp = data.toJS();
  const temp1 = temp.hits.hits;
  for (let i = 0; i < temp1.length; i++) { // eslint-disable-line
    array.push(temp1[i]._source); // eslint-disable-line
  }
  return array;
};

const getAllRequests = (data) => {
  const allRequests = data.toJS();
  return allRequests.sort((a, b) =>
    new Date(b.created_time) - new Date(a.created_time));
};

export const initialState = Map({
  profile: Map(),
  error: Map(),
  requested: false,
  allPostings: Map(),
  fetchRequest: false,
  allRequests: Map(),
  requestLoaded: false,
  conversationUpdated: false,
  divisionBasedStudents: Map(),
});

const handlers = {
  [REQUESTED](state) {
    return state.merge({
      requested: true,
      error: Map(),
      requestLoaded: false,
    });
  },
  [SUCCESSFUL](state, action) {
    return state.merge({
      requested: false,
      profile: action.data,
    });
  },
  [FAILED](state, action) {
    return state.merge({
      requested: false,
      error: action.error,
    });
  },
  [REQUEST_REQUESTED](state) {
    return state.merge({
      // requestLoaded: false,
    });
  },
  [REQUEST_SUCCESSFUL](state, action) {
    return state.merge({
      fetchRequest: false,
      allRequests: getAllRequests(action.data),
      requestLoaded: true,
    });
  },
  [REQUEST_FAILED](state, action) {
    return state.merge({
      requested: false,
      requestLoaded: false,
      error: action.error,
    });
  },
  [ADD_CONVERSATION_REQUESTED](state) {
    return state.merge({
      conversationUpdated: true,
    });
  },
  [ADD_CONVERSATION_SUCCESSFUL](state) {
    return state.merge({
      conversationUpdated: false,
    });
  },
  [ADD_CONVERSATION_FAILED](state, action) {
    return state.merge({
      requested: false,
      conversationUpdated: false,
      error: action.error,
    });
  },
  [COACH_PROFILE_REQUESTED](state) {
    return state.merge({

    });
  },
  [COACH_PROFILE_SUCCESSFUL](state, action) {
    return state.merge({
      profile: action.data,
    });
  },
  [COACH_PROFILE_FAILED](state, action) {
    return state.merge({
      error: action.error,
    });
  },

  [DIVISION_STUDENT_REQUESTED](state) {
    return state.merge({
      isLoading: true,
    });
  },
  [DIVISION_STUDENT_SUCCESSFUL](state, action) {
    return state.merge({
      isLoading: false,
      divisionBasedStudents: getCuratedArrayFromElasticData(action.data),
    });
  },
  [DIVISION_STUDENT_FAILED](state, action) {
    return state.merge({
      error: action.error,
    });
  },
  [FILTER_DIVISION_STUDENT_REQUESTED](state) {
    return state.merge({
      isLoading: true,
    });
  },
  [FILTER_DIVISION_STUDENT_SUCCESSFUL](state, action) {
    return state.merge({
      isLoading: false,
      divisionBasedStudents: getCuratedArrayFromElasticData(action.data),
    });
  },
  [FILTER_DIVISION_STUDENT_FAILED](state, action) {
    return state.merge({
      error: action.error,
    });
  },
  [SESSION_LOGOUT](state) {
    return state.merge({
      profile: {},
      error: Map(),
      requested: false,
      allPostings: Map(),
      fetchRequest: false,
      allRequests: Map(),
      requestLoaded: false,
      conversationUpdated: false,
    });
  },
};

export const coachDashboard = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getError = state => state.coachDashboard.get('error');
const getProfile = state => state.coachDashboard.get('profile');
const IsRequested = state => state.coachDashboard.get('requested');
const getRequests = state => state.coachDashboard.get('allRequests');
const getFetchallRequests = state => state.coachDashboard.get('fetchRequest');
const getRequestLoaded = state => state.coachDashboard.get('requestLoaded');
const getConversationUpdated = state => state.coachDashboard.get('conversationUpdated');
const getDivisionBasedStudent = state => state.coachDashboard.get('divisionBasedStudents');
const getIsLoading = state => state.coachDashboard.get('isLoading');

export const coachDashboardSelector = createStructuredSelector({
  error: getError,
  profile: getProfile,
  requested: IsRequested,
  allRequests: getRequests,
  fetchRequest: getFetchallRequests,
  requestLoaded: getRequestLoaded,
  conversationUpdated: getConversationUpdated,
  divisionBasedStudents: getDivisionBasedStudent,
  isLoading: getIsLoading,
});



// WEBPACK FOOTER //
// ./src/containers/DashBoardCoach/redux.js